import { render, staticRenderFns } from "./ElementVideoInput.vue?vue&type=template&id=6978b9d9&"
import script from "./ElementVideoInput.vue?vue&type=script&lang=js&"
export * from "./ElementVideoInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports